import { FC } from "react"

export const BubbleIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg width="78" height="35" viewBox="0 0 78 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="77.6667" height="35" rx="4" fill="#F7F7F7" />
      <g clipPath="url(#clip0_176_1571)">
        <path
          d="M38.4375 15.0324C37.3888 15.0324 36.3517 15.4822 35.5629 16.3703V12H34V19.3589C34 21.7485 35.9369 23.6854 38.3265 23.6854C40.7162 23.6854 42.653 21.7485 42.653 19.3589C42.653 16.9692 40.8272 15.0324 38.4375 15.0324ZM38.3236 22.0173C36.8542 22.0173 35.6652 20.8254 35.6652 19.3589C35.6652 17.8924 36.8571 16.7004 38.3236 16.7004C39.793 16.7004 40.982 17.8924 40.982 19.3589C40.982 20.8254 39.793 22.0173 38.3236 22.0173Z"
          fill="#ACACAC"
        />
        <path
          d="M47.8662 14.713C46.8175 14.713 45.7804 15.1629 44.9916 16.051V11.6807H43.4287V19.0395C43.4287 21.4292 45.3656 23.3661 47.7552 23.3661C50.1449 23.3661 52.0817 21.4292 52.0817 19.0395C52.0817 16.6499 50.253 14.713 47.8662 14.713ZM47.7523 21.698C46.2829 21.698 45.0939 20.5061 45.0939 19.0395C45.0939 17.573 46.2858 16.3811 47.7523 16.3811C49.2217 16.3811 50.4107 17.573 50.4107 19.0395C50.4107 20.5061 49.2217 21.698 47.7523 21.698Z"
          fill="#ACACAC"
        />
        <path
          d="M24.9395 19.7962V14.9468H26.6163V19.7816C26.6163 21.0173 27.332 21.809 28.5386 21.809C29.7597 21.809 30.4608 21.0466 30.4608 19.7816V14.9468H32.1523V19.7962C32.1523 22.0369 30.7938 23.3632 28.5386 23.3632C26.3417 23.3661 24.9395 21.9931 24.9395 19.7962Z"
          fill="#ACACAC"
        />
        <path d="M55.1056 23.1674H53.4287V11.6807H55.1056V23.1674Z" fill="#ACACAC" />
        <path
          d="M64.5998 19.7056H58.1816C58.427 20.9851 59.3238 21.8557 60.9101 21.8557C61.8391 21.8557 62.9696 21.5051 63.7 20.9705L64.4011 22.2062C63.5627 22.8314 62.2364 23.3485 60.8488 23.3485C57.7696 23.3485 56.4434 21.1984 56.4434 19.0337C56.4434 17.7979 56.8231 16.7784 57.6031 15.9692C58.3802 15.16 59.4027 14.748 60.6384 14.748C61.8128 14.748 62.7885 15.1132 63.5364 15.8611C64.2843 16.6089 64.664 17.6139 64.664 18.8964C64.6582 19.1271 64.6436 19.4018 64.5998 19.7056ZM58.1786 18.3325H62.9667C62.8294 17.0355 61.8683 16.197 60.6326 16.197C59.3676 16.197 58.424 17.053 58.1786 18.3325Z"
          fill="#ACACAC"
        />
        <path
          d="M19.6138 14.713C18.565 14.713 17.5279 15.1629 16.7392 16.051V11.6807H15.1733V19.0395C15.1733 21.4292 17.1102 23.3661 19.4999 23.3661C21.8895 23.3661 23.8264 21.4292 23.8264 19.0395C23.8264 16.6499 22.0005 14.713 19.6138 14.713ZM19.4999 21.698C18.0304 21.698 16.8414 20.5061 16.8414 19.0395C16.8414 17.573 18.0333 16.3811 19.4999 16.3811C20.9693 16.3811 22.1583 17.573 22.1583 19.0395C22.1583 20.5061 20.9693 21.698 19.4999 21.698Z"
          fill="#ACACAC"
        />
        <path
          d="M14.037 23.3633C14.6275 23.3633 15.1062 22.8846 15.1062 22.2941C15.1062 21.7036 14.6275 21.2249 14.037 21.2249C13.4465 21.2249 12.9678 21.7036 12.9678 22.2941C12.9678 22.8846 13.4465 23.3633 14.037 23.3633Z"
          fill="#ACACAC"
        />
      </g>
      <defs>
        <clipPath id="clip0_176_1571">
          <rect width="52" height="11.9191" fill="white" transform="translate(12.8335 11.5405)" />
        </clipPath>
      </defs>
    </svg>
  )
}

